import React, { useState, useEffect } from 'react';
import { InputText, DropdownField, ImageUpload } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import { textPositionOptions } from 'core/constant/SELECT_OPTIONS';
import useFormHandlers from 'core/hooks/form/useFormHandlers';

const EditBannerModal = ({ show, banner, handleClose, handleSave, updating, errors }) => {
  const [formValues, setFormValues] = useState(banner);
  const { handleChange, handleFileChangeLocal, handleRemoveImageLocal } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(banner);
  }, [banner]);

  const handleSaveClick = () => {
    handleSave({ ...formValues, id: banner.id }, true);
  };

  return (
    <BaseModalForm show={show} title="Editar Banner" handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row form-group">
        <div className="col-md-6">
          <InputText
            label="Título"
            value={formValues?.title}
            onChange={(e) => handleChange('title', e.target.value)}
            placeholder="Ingrese el título del banner"
            error={errors.title}
          />
        </div>
        <div className="col-md-6">
          <InputText
            label="Descripción"
            value={formValues?.description}
            onChange={(e) => handleChange('description', e.target.value)}
            placeholder="Ingrese la descripción del banner"
            error={errors.description}
          />
        </div>
        <div className="col-md-6">
          <InputText
            label="Enlace"
            value={formValues?.link}
            onChange={(e) => handleChange('link', e.target.value)}
            placeholder="Ingrese el enlace del banner"
            error={errors.link}
          />
        </div>
        <div className="col-md-6">
          <InputText
            label="Texto del Botón"
            value={formValues?.buttonText}
            onChange={(e) => handleChange('buttonText', e.target.value)}
            placeholder="Ingrese el texto del botón"
            error={errors.buttonText}
          />
        </div>
        <div className="col-md-6">
          <DropdownField
            label="Posición del Texto"
            placeholder="Seleccione la posición del texto"
            value={formValues?.textPosition}
            options={textPositionOptions}
            onChange={(e) => handleChange('textPosition', e.value)}
            error={errors.textPosition}
          />
        </div>
        <div className="col-md-6">
          <ImageUpload
            label="Imagen del Banner"
            value={formValues?.backgroundImage}
            onFileChange={(e) => handleFileChangeLocal(e, 'backgroundImage')}
            onRemoveImage={() => handleRemoveImageLocal('backgroundImage')}
            error={errors.backgroundImage}
          />
        </div>
        <div className="col-md-6">
          <ImageUpload
            label="Imagen del Banner (Mobile)"
            value={formValues?.backgroundImageMobile}
            onFileChange={(e) => handleFileChangeLocal(e, 'backgroundImageMobile')}
            onRemoveImage={() => handleRemoveImageLocal('backgroundImageMobile')}
            error={errors.backgroundImageMobile}
          />
        </div>
      </div>
      {updating && <p>Actualizando...</p>}
    </BaseModalForm>
  );
};

export default EditBannerModal;